import { StateResolver, TourApi } from 'core/tour-v2/types';

import { AutoscalerSettingsState } from '../../../features-op/cluster/settings-op/easy-mode/types';

const base = {
  actionButtonProps: {
    text: 'Advanced Settings',
    disabled: true,
  },
};

const toggleOff = {
  ...base,
  canUpdate: false,
  isEnabled: false,
  isPending: false,
  isLoading: false,
  toggle: () => {},
};

const toggleOn = { ...toggleOff, isEnabled: true, canUpdate: true };

const willBeOn = (api: TourApi) => ({
  ...toggleOff,
  canUpdate: true,
  toggle: api.next,
});
const on = () => ({ ...toggleOn });
const off = () => ({ ...toggleOff });

export const getAutoscalerDemoData1: StateResolver<AutoscalerSettingsState> = ({
  api,
}) => {
  return {
    workloadAutoscaling: willBeOn(api),
    nodeAutoscaler: off(),
    evictor: off(),
    podMutator: off(),
    vulnerabilityDetection: off(),
    complianceChecks: off(),
  };
};

export const getAutoscalerDemoData2: StateResolver<
  AutoscalerSettingsState
> = () => {
  return {
    workloadAutoscaling: on(),
    nodeAutoscaler: off(),
    evictor: off(),
    podMutator: off(),
    vulnerabilityDetection: off(),
    complianceChecks: off(),
  };
};

export const getAutoscalerDemoData3: StateResolver<AutoscalerSettingsState> = ({
  api,
}) => {
  return {
    workloadAutoscaling: on(),
    nodeAutoscaler: off(),
    evictor: willBeOn(api),
    podMutator: off(),
    vulnerabilityDetection: off(),
    complianceChecks: off(),
  };
};

export const getAutoscalerDemoData4: StateResolver<AutoscalerSettingsState> = ({
  api,
}) => {
  return {
    workloadAutoscaling: on(),
    nodeAutoscaler: willBeOn(api),
    evictor: on(),
    podMutator: off(),
    vulnerabilityDetection: off(),
    complianceChecks: off(),
  };
};

export const getAutoscalerDemoData5: StateResolver<
  AutoscalerSettingsState
> = () => {
  return {
    workloadAutoscaling: on(),
    nodeAutoscaler: on(),
    evictor: on(),
    podMutator: off(),
    vulnerabilityDetection: off(),
    complianceChecks: off(),
  };
};
